import { colorSet } from '@theme';
import { styled } from '@mui/material';
import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails,
  ListItemButton as MuiListItemButton,
  ListItemIcon as MuiListItemIcon,
  Box
} from '@mui/material';
import { ChevronDownGray600Icon, ChevronRightGray600Icon } from '@assets/iconComponents';

export const Accordion = styled(MuiAccordion)({
  width: 200,
  padding: 0,
  backgroundColor: colorSet.gray100,
  boxShadow: 'none',
  margin: '0px 0px 25px 0px', // 접혀있을 시 margin
  '&:before': {
    display: 'none !important'
  }, // collapse시 상단에 선이 보이는 이슈 해결
  '&.Mui-expanded': {
    margin: '0px 0px 25px 0px'
  }
});

// 부모 메뉴(chevron icon - list item icon - 메뉴명)
export const AccordionSummary = styled(MuiAccordionSummary)({
  height: 20,
  minHeight: 20,
  margin: 0,
  padding: 0,
  flexDirection: 'row-reverse',
  '&.Mui-expanded': {
    minHeight: 20
  },
  '& .MuiAccordionSummary-content': {
    margin: '0px'
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'none'
  }
});

// 자식 메뉴들 컨테이너
export const AccordionDetails = styled(MuiAccordionDetails)({
  marginTop: '9px',
  padding: 0,
  border: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: '9px'
});

// 부모 메뉴의 list item icon
export const ListItemIcon = styled(MuiListItemIcon)({
  width: 20,
  minWidth: 0,
  height: 20,
  marginRight: '12px'
});

// 단일 메뉴
// 부모 메뉴의 경우 list item icon - 메뉴명
// 자식 메뉴의 경우 메뉴명
export const ListItemButton = styled(MuiListItemButton)({
  padding: 0
});

export const AccordionExpandIcon = () => {
  return (
    <Box
      sx={{
        marginRight: '4px',
        '.Mui-expanded & > .collapsIconWrapper': {
          display: 'none'
        },
        '.expandIconWrapper': {
          display: 'none'
        },
        '.Mui-expanded & > .expandIconWrapper': {
          display: 'block'
        }
      }}
    >
      <div className="expandIconWrapper">
        <ChevronDownGray600Icon />
      </div>
      <div className="collapsIconWrapper">
        <ChevronRightGray600Icon />
      </div>
    </Box>
  );
};
